export const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/;
export const emailSeparatorRegex = /[,\s]/g;
export const spaceOrCommaSeparatedEmail = /^[\w-.]+@([\w-]+\.)+[\w-]{2,}(\s+|,\s*)$/;
